// extracted by mini-css-extract-plugin
export default {"warpper":"ft_warpper__iXldd","warpper__main":"ft_warpper__main__fh-RV","warpper__main__title":"ft_warpper__main__title__QROh7","warpper__main__info":"ft_warpper__main__info__eRBrr"};